import { ImportantDocumentFlags } from 'components/documents/important-document-flags';
import { documentTypeMapping, type IImportantTripDocumentFlagsProps } from './types';

export const ImportantTripDocumentFlags: React.FC<IImportantTripDocumentFlagsProps> = (props) => {
  const { documents } = props;

  return <ImportantDocumentFlags documents={documents} documentTypeMapping={documentTypeMapping} />;
};
